<template>
  <div>
    <div v-if="dataList" class="row">
      <div v-for="(obj, index) in dataList" :key="index" class="nx-card pt-1 col-md-4" @click="goDetails(obj)">
        <div class="nx-card-block cursor-pointer">
          <b-avatar :text="obj && obj.pessoa.nomeAssociado ? getInitialName(obj.pessoa.nomeAssociado) : ''" class="mr-3" size="5rem" style="float: left;"></b-avatar>
          <div><strong style="font-size: 16px;">{{obj.pessoa.nomeAssociado}}</strong></div>
          <div v-if="obj.pessoa.tipoPessoa === 'PF' || obj.pessoa.tipoPessoa === 'FÍSICA' || obj.pessoa.tipoPessoa === 'FISICA'">CPF: {{getValueFormatted(obj.pessoa.document, 'PF')}}</div>
          <div v-else>CNPJ: {{getValueFormatted(obj.pessoa.document, 'PJ')}}</div>
          <div>Número Sisbr: {{obj.numSisbr}}</div>
          <div>PA: {{obj.pa && obj.pa.numero + ' - ' + obj.pa.descricao}}</div>
          <div>Gerente Sisbr: {{obj.gerenteSisBR && obj.gerenteSisBR.pessoa && obj.gerenteSisBR.pessoa && obj.gerenteSisBR.pessoa.nome}}</div>
          <div>{{$lang.RelationchipManager.Label}}: {{obj.gerenteRelacionamento && obj.gerenteRelacionamento.pessoa && obj.gerenteRelacionamento.pessoa && obj.gerenteRelacionamento.pessoa.nome}}</div>
          <!-- <p> {{ obj }}</p> -->
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-center mt-5 pt-5">{{$lang.Common.DataTable.NoRecordsFound}}</div>
    </div>
  </div>
</template>
<script>
// import router from '@/router'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'AssociateList',
  mixins: [ActionsForm],
  data () {
    return {
      associateData: null
    }
  },
  computed: {
    dataList () {
      let result = null
      if (this.associateData && this.associateData.totalElements > 0) {
        result = this.associateData.content
      }
      return result
    }
  },
  methods: {
    goDetails (obj) {
      this.$emit('edit', obj.id)
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getValueFormatted (value, type) {
      return Tools.formatCpfCnpj(value, type)
    }
  }
}
</script>
<style scoped>
  .title-line {
    width: 40px;
    height: 6px;
    margin: 37px 267px 9px 0px;
    border-radius: 3px;
    background-color: #707070;
  }
  .bg-crm {
    bottom: 59px;
    position: fixed;
    right: 27px;
  }
  .nx-card {
    cursor: pointer;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background-color: #f5f5f5;
    border: 1px solid #cfd8dc;
    background-clip: border-box;
    /* border-radius: 0.25rem; */
  }
  .nx-card-block {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/associatelist.vue